import { computed, defineComponent, useCssModule } from '@nuxtjs/composition-api';
import { getArticleInfo } from '~/utils';
export default defineComponent({
    name: 'CardBackgroundMobile',
    props: {
        data: {
            required: true,
            type: Object,
        },
        options: {
            default: () => {
                return {
                    theme: 'dark',
                };
            },
            type: Object,
        },
        size: {
            required: true,
            type: Object,
        },
    },
    setup(props, { root }) {
        /**
         * Article info.
         */
        const articleInfo = getArticleInfo.call(root, props.data);
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        /**
         * Header entries.
         */
        let entries = [];
        if (!props.data?.['path' || 'url_alias']?.includes('adfox.ru')) {
            entries = [articleInfo.publishedAt, ...articleInfo.rubrics].filter(Boolean);
        }
        /**
         * Detects rating.
         */
        const isRating = computed(() => props.data.type === 'rating');
        return {
            articleInfo,
            css,
            entries,
            isRating,
        };
    },
});
